<div class="po-text-center po-mt-2" *ngIf="readCode">
    <video #videoElement width="100%" height="auto" autoplay></video>
</div>